// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"e2ff468f85--tooltip--Rln6T","arrow":"e2ff468f85--arrow--GMnRq"};